const dynamicParametersDatasets = ["MDO", "MDB"];

export type DynamicParametersDataset = typeof dynamicParametersDatasets[number];

export const isDynamicParametersDataset = (input: string): boolean =>
  dynamicParametersDatasets.includes(input);

export interface DynamicParametersDataModel {
  dataset: DynamicParametersDataset;
  settlementDate: string;
  settlementPeriod: number;
  timeFrom: string;
  timeTo: string;
  levelFrom: number;
  levelTo: number;
  nationalGridBmUnit: string;
  bmUnit: string;
}
